<template>
    <slot />
</template>

<script setup>
defineOptions({ inheritAttrs: false });

const props = defineProps(
{
    id         : { type: String, default: Date.now().toString() },
    title      : { type: String, default: '' },
    class      : { type: String, default: '' },
    before     : { type: [ String, Object ] },
    after      : { type: [ String, Object ] },
    active     : { type: Boolean, default: false },
    removeable : { type: Boolean, default: false }
});
</script>